import React, { useEffect, useState } from "react";
import logo from "../../assets/images/logo.png";
import { Button, Form, Input, message } from "antd";
import { UserOutlined } from "@ant-design/icons";
import { useNavigate } from "react-router-dom";
import { Helmet } from "react-helmet";
import { ForgotPasswordAPI } from "../../API/ForgotPasswordAPI";

const validateMessages = {
  required: "${label} is required!",
  types: {
    email: "${label} is not valid!",
  },
};

export default function ForgotPassword() {
  const [form] = Form.useForm();
  const navigate = useNavigate();
  const [loadingState, setLoadingState] = useState(false);

  const onFinish = (values) => {
    const bodyData = {
      email: values.email.trim(),
    };
    getOtpFun(bodyData);
  };

  async function getOtpFun(bodydata) {
    setLoadingState(true);
    await ForgotPasswordAPI.getForgotOTP(bodydata)
      .then((res) => {
        if (res.status === true) {
          localStorage.setItem("forgotEmail", bodydata.email);
          navigate("/forgot-password/verify-otp");
        } else {
          message.error(res?.message, 8);
        }
      })
      .catch(() => message.error("Internal Server Error", 8))
      .finally(() => setLoadingState(false));
  }

  useEffect(() => {
    localStorage.setItem("forgotEmail", "");
    localStorage.setItem("otpKey", "");
  }, []);

  const handleEmailChange = (e) => {
    const trimmedValue = e.target.value.trim();
    form.setFieldsValue({ email: trimmedValue });
  };

  return (
    <div
      style={{
        height: "100vh",
        width: "100%",
        background: "#fff",
      }}
    >
      <Helmet>
        <title>SpecOptimzer</title>
      </Helmet>
      <div
        style={{
          overflow: "hidden",
          background: "linear-gradient(180deg, #D3E4FF 0%, #FFFFFF 100%)",
          height: "100%",
          display: "flex",
          alignItems: "stretch",
          justifyContent: "center",
        }}
      >
        <div className="reset_password_wraper">
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "stretch",
              width: "60%",
            }}
          >
            <div style={{ textAlign: "center" }}>
              <img
                src={logo}
                style={{ marginBottom: "40px", width: "200px" }}
                alt={`img_${logo}`}
              />
              {/* <p className='reset_paragraph'>For continued access, please reset your password.</p> */}
            </div>
            <Form
              form={form}
              name="forgot_password"
              className="login-form"
              onFinish={onFinish}
              autoComplete="off"
              layout="vertical"
              requiredMark="optional"
              validateMessages={validateMessages}
            >
              <Form.Item
                name="email"
                label="Email"
                rules={[{ required: true, type: "email" }]}
              >
                <Input
                  name="email"
                  size="large"
                  prefix={<UserOutlined className="site-form-item-icon" />}
                  onChange={handleEmailChange}
                />
              </Form.Item>

              <Form.Item style={{}}>
                <Button
                  type="primary"
                  htmlType="submit"
                  size="large"
                  style={{ width: "100%", marginTop: "20px" }}
                  loading={loadingState}
                >
                  Submit
                </Button>
                <p style={{ textAlign: "left", marginTop: "10px" }}>
                  Or <a href="/login">Log in now!</a>
                </p>
              </Form.Item>
            </Form>
          </div>
        </div>
      </div>
    </div>
  );
}
